module.exports = __webpack_public_path__ + "static/media/employee.dd4f1f7d.svg";